// Fix for ResizeObserver loop completed with undelivered notifications error
// This is a harmless error that occurs when charts or dynamic components trigger resize loops
if (typeof window !== 'undefined') {
  const resizeObserverErr = window.console.error;
  window.console.error = (...args) => {
    const firstArg = args && args[0];
    if (firstArg && firstArg.indexOf && firstArg.indexOf('ResizeObserver loop completed with undelivered notifications') !== -1) {
      // Suppress this specific error as it's harmless
      return;
    }
    resizeObserverErr(...args);
  };
}